export const en = {
  // ── Navigation ──
  'nav.seer': 'Seer',
  'nav.cosmos': 'Cosmos',
  'nav.chart': 'Chart',
  'nav.bonds': 'Bonds',

  // ── Header ──
  'header.brand': 'The Seer',

  // ── Onboarding ──
  'onboarding.the': 'The',
  'onboarding.seer': 'Seer',
  'onboarding.loading': 'Aligning the cosmos...',
  'onboarding.warnPrecision': 'Readings may be less precise today',

  // ── Intro ──
  'intro.line1': 'The stars have been waiting',
  'intro.line2': 'Your chart.',
  'intro.line3': 'Your oracle.',
  'intro.line4': 'Your truth.',
  'intro.line5': 'To see, I must know when you arrived',
  'intro.tap': 'tap',

  // ── Birth Data Form ──
  'form.title': 'The Seer requires your celestial coordinates',
  'form.titleEdit': 'Realign your celestial coordinates',
  'form.name': 'Name',
  'form.namePlaceholder': 'Your name',
  'form.date': 'Date of Birth',
  'form.time': 'Time of Birth',
  'form.place': 'Place of Birth',
  'form.placePlaceholder': 'Start typing...',
  'form.noTime': "I don't know my birth time",
  'form.noTimeHint': 'Noon will be used. Rising sign and houses may be less accurate, but readings still work.',
  'form.enter': 'Enter',
  'form.save': 'Save',
  'form.email': 'Email',
  'form.emailPlaceholder': 'your@email.com',
  'form.emailHint': 'Optional — for cosmic updates and transit alerts',
  'form.emailConsent': 'Send me weekly oracle insights and cosmic events',
  'form.errorDate': 'Enter your birth date',
  'form.errorCity': 'Select a city from suggestions',

  // ── Oracle ──
  'oracle.acknowledge': 'I see you, {name}.',
  'oracle.acknowledgeAction': 'Ask away.',
  'oracle.sleeping': 'I sleep until summoned.',
  'oracle.summon': 'Summon',
  'oracle.askAgain': 'Ask Again',
  'oracle.ask': 'Ask',
  'oracle.deeper': 'The oracle peers deeper...',
  'oracle.learnMore': 'Learn more',
  'oracle.whyOracle': 'Why does the oracle say this?',
  'oracle.whenChange': 'When will this change?',
  'oracle.exhausted': 'The oracle has spoken. Ask again for a new reading.',
  'oracle.copied': 'Copied to clipboard',
  'oracle.timing': 'Timing',
  'oracle.deeperInsight': 'Deeper Insight',

  // ── Oracle Hints ──
  'hint.oracle': 'Speak your question. The Seer will answer.',
  'hint.cosmos': 'Your daily cosmic weather',
  'hint.chart': 'Your birth sky, mapped',
  'hint.bonds': 'Compare your chart with another soul',

  // ── Question Placeholders (atmospheric — not duplicating suggestion pills) ──
  'q.placeholder1': 'The stars are listening...',
  'q.placeholder2': 'Ask what weighs on your heart...',
  'q.placeholder3': 'What truth do you seek?',
  'q.placeholder4': 'The cosmos awaits your question...',
  'q.placeholder5': 'Speak what you need to know...',
  'q.placeholder6': 'What does your soul wonder?',
  'q.errorEmpty': 'Speak your question first',
  'q.errorMeaningful': 'Ask a meaningful question',

  // ── Suggested Questions ──
  'suggested.divider': 'or let the stars choose',

  // ── Seer Suggested Questions ──
  // Love & relationships — answerable from the user's OWN chart
  'sq.loveNature': 'What kind of lover am I?',
  'sq.loveNeed': 'What do I really need in love?',
  'sq.loveAttract': 'What type of person do I attract?',
  'sq.lovePattern': 'What patterns do I repeat in love?',
  'sq.loveReady': 'Am I ready for love right now?',
  'sq.loveDeserve': 'What kind of love do I deserve?',
  'sq.tellFeel': 'Should I tell them how I feel?',
  'sq.settlingDown': 'Am I settling?',
  'sq.loveBlocking': 'What is blocking me in love?',
  'sq.whoDrawn': 'What kind of people am I drawn to?',

  // Career & money (high stakes, screenshotable)
  'sq.quitJob': 'Should I quit my job?',
  'sq.wrongField': 'Am I in the wrong field?',
  'sq.whatJob': 'What job should I get?',
  'sq.payOff': 'Will this pay off?',
  'sq.rightMove': 'Is this the right move?',

  // Self-discovery (what makes users come back)
  'sq.mainCharacter': 'Am I the main character?',
  'sq.superpower': 'What is my superpower?',
  'sq.hiddenStrength': 'What is my hidden strength?',
  'sq.myCharm': 'What is my charm?',
  'sq.naturallyGifted': 'What am I naturally gifted at?',

  // Gut checks & crossroads
  'sq.beOkay': 'Will I be okay?',
  'sq.trustGut': 'Should I trust my gut?',
  'sq.mistake': 'Am I making a mistake?',
  'sq.rightPath': 'Is this the right path?',
  'sq.notSeeing': 'What am I not seeing?',
  'sq.letGo': 'Should I let go?',

  // Timing & spiritual
  'sq.isItTime': 'Is it time?',
  'sq.willPass': 'Will this pass?',
  'sq.focusNow': 'What should I focus on right now?',
  'sq.readyFor': 'What am I ready for?',

  // ── Cosmic Dashboard ──
  'cosmos.your': 'Your',
  'cosmos.title': 'Cosmic Day',
  'cosmos.lunar': 'Lunar Phase',
  'cosmos.transits': 'Active Transits',
  'cosmos.coming': 'Coming Up',
  'cosmos.retrogrades': 'Retrogrades',
  'cosmos.back': 'Back',
  'cosmos.tomorrow': 'tomorrow',
  'cosmos.inDays': 'in {days} days',
  'cosmos.updated': 'Updated {time}',

  // ── Natal Chart ──
  'chart.your': 'Your',
  'chart.title': 'Natal Chart',
  'chart.reading': 'The Seer Sees',
  'chart.keyPoints': 'Key Points',
  'chart.planets': 'Planets',
  'chart.houses': 'Houses',
  'chart.placidus': 'Placidus',
  'chart.wholeSign': 'Whole Sign',
  'chart.house': '{n} house',

  // ── Planet Meanings ──
  'planet.sun': 'Your core identity',
  'planet.moon': 'Your emotions and inner world',
  'planet.mercury': 'How you think and communicate',
  'planet.venus': 'How you love and what you value',
  'planet.mars': 'Your drive and how you take action',
  'planet.jupiter': 'Where you find luck and growth',
  'planet.saturn': 'Your discipline and life lessons',
  'planet.uranus': 'Where you break the rules',
  'planet.neptune': 'Your dreams and intuition',
  'planet.pluto': 'Your deepest transformation',
  'planet.ascendant': 'How the world sees you',
  'planet.midheaven': 'Your public image and career path',
  'planet.northNode': "Your soul's direction",
  'planet.chiron': 'Your deepest wound and healing gift',

  // ── Sign Qualities ──
  'sign.Aries': 'bold, direct, action-driven',
  'sign.Taurus': 'steady, sensual, grounded',
  'sign.Gemini': 'curious, adaptable, expressive',
  'sign.Cancer': 'nurturing, intuitive, protective',
  'sign.Leo': 'confident, creative, warm',
  'sign.Virgo': 'precise, practical, devoted',
  'sign.Libra': 'harmonious, fair, relationship-oriented',
  'sign.Scorpio': 'intense, transformative, deep',
  'sign.Sagittarius': 'adventurous, philosophical, free',
  'sign.Capricorn': 'ambitious, disciplined, strategic',
  'sign.Aquarius': 'independent, visionary, unconventional',
  'sign.Pisces': 'empathetic, dreamy, spiritually attuned',

  // ── Chart Questions ──
  'chartQ.ask': 'Ask about your chart',
  'chartQ.askAnother': 'Ask another',
  'chartQ.backToChart': 'Back to chart',
  'chartQ.placeholder': 'Ask the Seer about your chart...',
  'chartQ.orAsk': 'or ask the stars',
  'chartQ.superpower': 'What is my superpower?',
  'chartQ.loveStyle': 'How do I love?',
  'chartQ.career': 'What career suits me?',
  'chartQ.purpose': 'What is my purpose?',
  'chartQ.blind': 'What is my blind spot?',
  'chartQ.gift': 'What is my biggest gift?',
  'chartQ.shadow': 'What is my shadow side?',
  'chartQ.attract': 'What do I attract?',
  'chartQ.lesson': 'What is my life lesson?',
  'chartQ.fear': 'What am I afraid of?',
  'chartQ.charm': 'What makes me magnetic?',
  'chartQ.compatible': 'What signs am I most compatible with?',

  // ── Cosmos Questions ──
  'cosmosQ.ask': 'Ask about your day',
  'cosmosQ.placeholder': 'Ask the Seer about your cosmic day...',
  'cosmosQ.orAsk': 'or ask about today',
  'cosmosQ.focusToday': 'What should I focus on today?',
  'cosmosQ.feelOff': 'Why do I feel off?',
  'cosmosQ.loveToday': 'Is today good for love?',
  'cosmosQ.avoidToday': 'What should I avoid today?',
  'cosmosQ.bestFor': 'What is today best for?',
  'cosmosQ.energy': 'What is strongest today?',

  // ── Compatibility / Bonds ──
  'bonds.choose': 'Choose a soul to compare',
  'bonds.addPrompt': 'Add a second soul to reveal what lies between you',
  'bonds.addProfile': '+ Add Profile',
  'bonds.chooseAnother': 'Choose another soul',
  'bonds.draws': 'What Draws You Together',
  'bonds.tests': 'What Tests You',
  'bonds.harmony': 'Elemental Harmony',
  'bonds.resonance': 'Cosmic Resonance',
  'bonds.askBond': 'Ask about this bond',
  'bonds.backReading': 'Back to reading',
  'bonds.askAnother': 'Ask another',
  'bonds.placeholder': 'Will this work between us?',
  'bonds.orAsk': 'or ask the stars',
  'bonds.strong': 'strong',
  'bonds.present': 'present',
  'bonds.subtle': 'subtle',

  // ── Bond Suggested Questions ──
  'bondQ.together': 'What brings us together?',
  'bondQ.places': 'What places would we enjoy?',
  'bondQ.fight': 'What might we fight about?',
  'bondQ.challenge': 'What is our biggest challenge?',
  'bondQ.dates': 'What kind of dates suit us?',
  'bondQ.unique': 'What makes this bond unique?',
  'bondQ.balance': 'How do we balance each other?',
  'bondQ.compatible': 'Are we truly compatible?',
  'bondQ.chemistry': 'Is there real chemistry between us?',
  'bondQ.last': 'Will this last?',
  'bondQ.trust': 'Can I trust them?',
  'bondQ.timing': 'Is now the right time?',
  'bondQ.serious': 'Are they serious about me?',

  // ── Reading History ──
  'history.the': 'The Oracle',
  'history.remembers': 'Remembers',
  'history.empty': 'No readings yet.',
  'history.emptyHint': 'Ask the Seer a question to begin your journal.',
  'history.yes': 'Yes',
  'history.leaningYes': 'Leaning Yes',
  'history.uncertain': 'Uncertain',
  'history.leaningNo': 'Leaning No',
  'history.no': 'No',
  'history.unclear': 'Unclear',

  // ── Settings ──
  'settings.title': 'Settings',
  'settings.sound': 'Sound',
  'settings.history': 'Reading History',
  'settings.profiles': 'Profiles',
  'settings.newProfile': 'New Profile',
  'settings.editProfile': 'Edit Profile',
  'settings.language': 'Language',

  // ── Footer ──
  'footer.terms': 'Terms',
  'footer.privacy': 'Privacy',
  'footer.disclaimer': 'For reflection, not prediction.',

  // ── Today's Bond ──
  'todayBond.energy': "Today's Energy",
  'todayBond.happening': "What's happening",
  'todayBond.advice': "Today's advice",
  'todayBond.mood': 'The mood between you:',
  'todayBond.intense': 'intense',
  'todayBond.active': 'active',
  'todayBond.gentle': 'gentle',
  'todayBond.quiet': 'quiet',

  // ── Mood Descriptors ──
  'mood.electric': 'high energy, charged',
  'mood.tender': 'soft, open-hearted',
  'mood.volatile': 'intense, unpredictable',
  'mood.still': 'calm, waiting',
  'mood.magnetic': 'pulling together',
  'mood.fated': 'heavy with destiny',
  'mood.restless': 'uneasy, seeking',
  'mood.raw': 'exposed, unfiltered',
  'mood.expanding': 'growing, opening up',
  'mood.dissolving': 'boundaries softening',

  // ── Moon Rituals ──
  'ritual.newMoon': 'New Moon — Set intentions. Ask what to begin.',
  'ritual.fullMoon': 'Full Moon — Seek clarity. Ask what to release.',

  // ── Profile ──
  'profile.addProfile': '+ Add Profile',

  // ── Vision Limits (soft paywall hints) ──
  'vision.twoCast': 'Two visions cast today \u00B7 One remains',
  'vision.oneLeft': 'One vision remains. Ask with intention.',
  'vision.generous': 'The Seer has been generous today.',
  'vision.noLimit': 'Testing phase \u00B7 No limit mode unlocked',

  // ── General ──
  'general.back': 'Back',
  'general.dismiss': 'Dismiss',
  'general.close': 'Close',
} as const;

export type TranslationKey = keyof typeof en;
